import type { Variants, Transition } from 'framer-motion';

// ---------------------------------------------------------------------------
// Centralized motion language. Import these instead of writing ad-hoc
// transitions so timing/easing stays consistent across the whole site.
// ---------------------------------------------------------------------------

// Easing curves (cubic-bezier control points)
export const ease = {
  // smooth, slightly weighted — the default for entrances
  out: [0.22, 1, 0.36, 1] as [number, number, number, number],
  // gentle in/out for ambient, looping motion
  inOut: [0.45, 0, 0.55, 1] as [number, number, number, number],
  // snappy for hover/press micro-interactions
  snappy: [0.34, 1.56, 0.64, 1] as [number, number, number, number],
};

export const duration = {
  fast: 0.3,
  base: 0.6,
  slow: 0.9,
};

export const springConfig: Transition = {
  type: 'spring',
  stiffness: 150,
  damping: 20,
  mass: 0.5,
};

// Reveal a single block as it scrolls into view.
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: duration.base, ease: ease.out },
  },
};

export const fade: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: duration.base, ease: ease.out } },
};

// Parent that staggers its direct children (use with `staggerItem`).
export const stagger = (staggerChildren = 0.08, delayChildren = 0): Variants => ({
  hidden: {},
  visible: {
    transition: { staggerChildren, delayChildren },
  },
});

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: duration.base, ease: ease.out },
  },
};

// Shared viewport config so reveals trigger consistently.
export const viewportOnce = { once: true, amount: 0.25, margin: '-60px' } as const;
